import { TagItem, EventItem, LocationItem, UserItem, MessageItem, CompanyItem, TagType, ICompanyItem } from './../models/Item';
import { Injectable, LOCALE_ID } from '@angular/core';
import { Item } from '../models/Item';
import { AngularFirestore, AngularFirestoreCollection, AngularFirestoreDocument } from 'angularfire2/firestore';
import { AngularFireStorage } from 'angularfire2/storage';
import { Observable, Subscriber } from 'rxjs';
import { Subject } from 'rxjs';
import { AngularFireAuth } from 'angularfire2/auth';
import { stringify } from 'querystring';

@Injectable({
  providedIn: 'root'
})
export class DbmanagerService {
  currentUserID: string;
  company: string;
  sumclick = 0;
  tagItems: Map<string, TagItem>;
  eventItems: Map<string, EventItem>;
  locations: Map<string, LocationItem>;
  messages: Map<string, MessageItem>;
  users: Map<string, UserItem>;

  items: Map<string, Item>;
  private itemsupdated = new Subject<Map<string, Item>>();

  private locationRecived = new Subject<Map<string, LocationItem>>();
  private usersRecived = new Subject<Map<string, UserItem>>();
  private messagesRecived = new Subject<Map<string, MessageItem>>();

  private histTagRecived = new Subject<Array<TagItem>>();
  private histEventRecived = new Subject<Array<EventItem>>();

  private uploadPhotoEventRecived = new Subject<string>();
  private photosUploaded = new Subject<Map<number, string>>();

  private loginStatus = new Subject<boolean>();
  private tagExist = new Subject<boolean>();
  private leftTagsChanged = new Subject<CompanyItem>();

  public logged: boolean;

  public type = 'commercial'; // inventory itp

  private leftTags: CompanyItem;


  constructor(public afs: AngularFirestore, private afAuth: AngularFireAuth, public afStorage: AngularFireStorage) {
    this.logged = false;
    this.tagItems = new Map<string, TagItem>();
    this.eventItems = new Map<string, EventItem>();
    this.items = new  Map<string, Item>();
    this.locations = new  Map<string, LocationItem>();
    this.users = new  Map<string, UserItem>();
    this.messages = new  Map<string, MessageItem>();
   }

   public emailLogin(email, password) {
    this.currentUserID = email;
    return this.afAuth.auth.signInWithEmailAndPassword(email, password)
      .then((user) => {
        this.afs.collection('SUBSCRIBERS').doc(email).valueChanges().subscribe(subs => {
          this.company = subs['COMPANY'];
          this.logged = true;
          this.loginStatus.next(true);
        });
      })
      .catch(error => this.loginStatus.next(false));
  }

  public getLeftTags(): CompanyItem {
    return this.leftTags;
  }

  public getUsers() {
    this.afs.collection('COMPANIES').doc(this.company).collection('USERS').
    valueChanges().subscribe(users => {
      users.forEach(user => {
        const u: UserItem = {
                                    ID: user.ID,
                                    NAME: user.NAME,
                                    SURNAME: user.SURNAME,
                                    LOGIN: user.LOGIN,
                                    PASSWORD: user.PASSWORD,
                                    DEV_ID: user.DEV_ID,
                                    TYPE: user.TYPE,
                                    ROLE: user.ROLE,
                                    EXPIRATION_DATE: user.EXPIRATION_DATE};

        this.users.set(u.ID, u)  ;
      });
      this.usersRecived.next(this.users);
      this.getData();
    });
  }

  public createNewTag(uid, tag, event) {
    this.afs.collection('COMPANIES').doc(this.company).collection('TAGS').doc(uid).set(tag).then((() => {
      console.log('Tag Added');
    }));
    this.afs.collection('COMPANIES').doc(this.company).collection('EVENTS').doc(uid).set(event).then((() => {
      console.log('event Added');
    }));
    this.afs.collection('COMPANIES').doc(this.company).update({TAGS_QR_LEFT: --this.leftTags.QRTagsLeft});
  }

  public getData() {

    this.afs.collection('COMPANIES').doc(this.company).
    valueChanges().subscribe(val => {
      this.leftTags = new CompanyItem((val as ICompanyItem).TAGS_QR_LEFT,
                                      (val as ICompanyItem).TAGS_NFC_LEFT,
                                      (val as ICompanyItem).TAGS_UHF_LEFT);
      this.leftTagsChanged.next(this.leftTags);
    });

    this.afs.collection('COMPANIES').doc(this.company).collection('LOCATIONS').
    valueChanges().subscribe(locations => {
      locations.forEach(location => {
        const mp = new Map();
        try {
        Object.keys ( location.MAP ). forEach (k => { mp.set(k, location.MAP[k]); });
        } catch {

        }
        const loc: LocationItem = { ADDRESS: location.ADDRESS,
                                    INVENTORY_DATE: location.INVENTORY_DATE,
                                    INVENTORY_STATUS: location.INVENTORY_STATUS,
                                    MAP: mp,
                                    NAME: location.NAME,
                                    PREVIOUS_INVENTORY: location.EVENT_DATETIME,
                                    SIZE: location.SIZE,
                                    LOCATION_ID: location.LOCATION_ID};

        this.locations.set(location.NAME, loc)  ;
      });
      this.locationRecived.next(this.locations);
    });

    this.afs.collection('COMPANIES').doc(this.company).collection('TAGS').
    valueChanges().subscribe(tags => {
      tags.forEach(tag => {
        this.tagItems.set(tag.TAG_UID, tag);
        if (this.items.has(tag.TAG_UID)) {
          const name = this.users.get(tag.USER_ID).NAME;
          const surname = this.users.get(tag.USER_ID).SURNAME;
          const item: Item = {DESCRIPTION: tag.DESCRIPTION,
                              STATE: this.items.get(tag.TAG_UID).STATE,
                              REMARKS: this.items.get(tag.TAG_UID).REMARKS,
                              TAG_UID: this.items.get(tag.TAG_UID).TAG_UID,
                              LOCATION: this.items.get(tag.TAG_UID).LOCATION,
                              EDIT_DATETIME: this.items.get(tag.TAG_UID).EDIT_DATETIME,
                              TITLE: tag.TITLE,
                              MARK: tag.MARK,
                              USERNAME: name,
                              USERSURNAME: surname,
                              PURCHASE_DATE: tag.PURCHASE_DATE,
                              CATEGORY: tag.CATEGORY};
          this.items.set(tag.TAG_UID, item)  ;
          this.itemsupdated.next(this.items);
        }
      });
    });

    this.afs.collection('COMPANIES').doc(this.company).collection('EVENTS').
      valueChanges().subscribe(events => {
        events.forEach(event => {
          this.eventItems.set(event.TAG_UID, event);
          let desc = '';
          let title = '';
          let mark = '';
          let category = '';
          let date ;
          let name;
          let surname;
          let purchase: Date;
          if (this.tagItems.has(event.TAG_UID)) {
            const tag = this.tagItems.get(event.TAG_UID) ;
            desc = tag.DESCRIPTION ;
            title = tag.TITLE;
            mark = tag.MARK;
            category = tag.CATEGORY;
            purchase = tag.PURCHASE_DATE;

            if (tag.EDIT_DATETIME > event.EVENT_DATETIME) {
              date = tag.EDIT_DATETIME;
              name = this.users.get(tag.USER_ID).NAME;
              surname = this.users.get(tag.USER_ID).SURNAME;
            } else {
              date = event.EVENT_DATETIME;
              name = this.users.get(event.USER_ID).NAME;
              surname = this.users.get(event.USER_ID).SURNAME;
            }
          }
          const item: Item = {DESCRIPTION: desc, // to wyjeba z tego
                            STATE: event.STATE,
                            REMARKS: event.REMARKS,
                            TAG_UID: event.TAG_UID,
                            LOCATION: event.LOCATION,
                            EDIT_DATETIME: date,
                            USERNAME: name,
                            USERSURNAME: surname,
                            TITLE: title,
                            MARK: mark,
                            PURCHASE_DATE: purchase,
                            CATEGORY: category};

          this.items.set(event.TAG_UID, item)  ;
        });
        this.itemsupdated.next(this.items);
      });
    this.afs.collection('COMPANIES').doc(this.company).collection('USERS').doc(this.currentUserID).collection('MESSAGES').
      valueChanges().subscribe(messages => {
        messages.forEach(message => {
          const mess: MessageItem = { CONTENT: message.CONTENT,
                                      TITLE: message.TITLE,
                                      KEY: message.KEY,
                                      TYPE: message.TYPE,
                                      CONFIRMED: message.CONFIRMED};
          this.messages.set(message.KEY, mess) ;
        });
        this.messagesRecived.next(this.messages);
      });
  }

   getItems(): Observable<Map<string, Item>> {
     return this.itemsupdated.asObservable();
   }

   uploadImage(UID: string, file) {
      const path = this.company + '/images/' + UID.replace(/:/g, '') + '.png' ;
      const ref = this.afStorage.ref(path);
      const task = ref.put(file).then((snapshot) => {
        ref.getDownloadURL().subscribe((url) => {
          this.uploadPhotoEventRecived.next(url);
        });
      });
   }

   uploadImages(UID: string, files: Map<number, string>) {
    const urls = new Map<number, string>();
    files.forEach((value, key) => {
      let path = '';
      if (key === -1) {
        path = this.company + '/images/' + UID.replace(/:/g, '') + '.png' ;
      } else {
        path = this.company + '/images/' + UID.replace(/:/g, '') + '_' + key.toString() + '.png' ;
      }
      urls.set(key, '');
      const ref = this.afStorage.ref(path);
      const task = ref.put(value).then((snapshot) => {
        const index = key;
        ref.getDownloadURL().subscribe((url) => {
          urls.set(index, url);
          let uploadInProgress = false;
          urls.forEach(urlValue => {
              if (urlValue.length === 0) {
                uploadInProgress = true;
              }
            });

          if (uploadInProgress === false) {
            this.photosUploaded.next(urls);
          }
        });
      });
    });
  }

  checkTagExisting(UID) {
    this.afs.collection('COMPANIES').doc(this.company).collection('TAGS').doc(UID).get().subscribe(tag => {
      if (tag.exists) {
        this.tagExist.next(true);
      } else {
        this.tagExist.next(false);
      }
    });
  }

  getHistory(UID) {
    const eventHistory = new Array<EventItem>();
    const tagHistory = new Array<TagItem>();

    this.afs.collection('COMPANIES').doc(this.company).collection('EVENTS').doc(UID).collection('HISTORY').
    valueChanges().subscribe(history => {
      history.forEach(change => {
        eventHistory.push(change);
      });
      this.histEventRecived.next(eventHistory);
    });

    this.afs.collection('COMPANIES').doc(this.company).collection('TAGS').doc(UID).collection('HISTORY').
    valueChanges().subscribe(history => {
      history.forEach(change => {
        tagHistory.push(change);
      });
      this.histTagRecived.next(tagHistory);
    });
  }

  updateTagItem(UID, data) {
    if (Object.keys(data).length > 0 ) {
      let tagHistData = new Object();
      const item = this.tagItems.get(UID);
      if (item.CATEGORY !== undefined) {tagHistData = Object.assign(tagHistData, {CATEGORY: item.CATEGORY}); }
      if (item.DESCRIPTION !== undefined) {tagHistData = Object.assign(tagHistData, {DESCRIPTION: item.DESCRIPTION}); }
      if (item.EDIT_DATETIME !== undefined) {tagHistData = Object.assign(tagHistData, {EDIT_DATETIME: item.EDIT_DATETIME}); }
      if (item.LINK !== undefined) {tagHistData = Object.assign(tagHistData, {LINK: item.LINK}); }
      if (item.LINKED_FIELDS !== undefined) {tagHistData = Object.assign(tagHistData, {LINKED_FIELDS: item.LINKED_FIELDS}); }
      if (item.MARK !== undefined) {tagHistData = Object.assign(tagHistData, {MARK: item.MARK}); }
      if (item.PHOTO !== undefined) {tagHistData = Object.assign(tagHistData, {PHOTO: item.PHOTO}); }
      if (item.PURCHASE_DATE !== undefined) {tagHistData = Object.assign(tagHistData, {PURCHASE_DATE: item.PURCHASE_DATE}); }
      if (item.REG_NUM !== undefined) {tagHistData = Object.assign(tagHistData, {REG_NUM: item.REG_NUM}); }
      if (item.TYPE !== undefined) {tagHistData = Object.assign(tagHistData, {TYPE: item.TYPE}); }
      if (item.SIZE !== undefined) {tagHistData = Object.assign(tagHistData, {SIZE: item.SIZE}); }
      if (item.TAG_UID !== undefined) {tagHistData = Object.assign(tagHistData, {TAG_UID: item.TAG_UID}); }
      if (item.TITLE !== undefined) {tagHistData = Object.assign(tagHistData, {TITLE: item.TITLE}); }
      if (item.USER_ID !== undefined) {tagHistData = Object.assign(tagHistData, {USER_ID: item.USER_ID}); }
      this.afs.collection('COMPANIES').doc(this.company).collection('TAGS').doc(UID).collection('HISTORY').add(tagHistData);
      this.afs.collection('COMPANIES').doc(this.company).collection('TAGS').doc(UID).update(data);
    }
  }

  updateEventItem(UID, data) {
    if (Object.keys(data).length > 0 ) {
      let eventHistData = new Object();
      const item = this.eventItems.get(UID);
      if (item.STATE !== undefined) {eventHistData = Object.assign(eventHistData, {STATE: item.STATE}); }
      if (item.USER_ID !== undefined) {eventHistData = Object.assign(eventHistData, {USER_ID: item.USER_ID}); }
      if (item.TAG_UID !== undefined) {eventHistData = Object.assign(eventHistData, {TAG_UID: item.TAG_UID}); }
      if (item.REMARKS !== undefined) {eventHistData = Object.assign(eventHistData, {REMARKS: item.REMARKS}); }
      if (item.LOCATION !== undefined) {eventHistData = Object.assign(eventHistData, {LOCATION: item.LOCATION}); }
      if (item.EVENT_DATETIME !== undefined) {eventHistData = Object.assign(eventHistData, {EVENT_DATETIME: item.EVENT_DATETIME}); }
      if ((item.PHOTOS !== undefined) && (item.PHOTOS['0'] !== undefined)) {
                  eventHistData = Object.assign(eventHistData, {PHOTOS: item.PHOTOS}); }
      if ((item.COORD !== undefined) && (item.COORD['A0'] !== undefined)) {
                  eventHistData = Object.assign(eventHistData, {COORD: {A0: {X: item.COORD['A0'].X, Y: item.COORD['A0'].Y}}}); }
      this.afs.collection('COMPANIES').doc(this.company).collection('EVENTS').doc(UID).collection('HISTORY').add(eventHistData);
      this.afs.collection('COMPANIES').doc(this.company).collection('EVENTS').doc(UID).update(data);
    }
  }

  confirmMessage(messDataKey) {
    this.afs.collection('COMPANIES').doc(this.company).collection('USERS').doc(this.currentUserID).
    collection('MESSAGES').doc(messDataKey).update({CONFIRMED: true});
  }

  updateInventoryStatus(status, Location) {
    let locationData = new Object();

    if (status === 'STARTED') {
      const previousInventory = new Array<string>();
      this.eventItems.forEach(tag => {
        if (tag.LOCATION === Location) {
          previousInventory.push(tag.TAG_UID);
        }
      });
      locationData = Object.assign(locationData, {INVENTORY_STATUS: status});
      locationData = Object.assign(locationData, {INVENTORY_DATE: new Date()});
      locationData = Object.assign(locationData, {PREVIOUS_INVENTORY: previousInventory});
    } else if (status === 'CANCELED') {
      locationData = Object.assign(locationData, {INVENTORY_STATUS: status});
    }
    this.afs.collection('COMPANIES').doc(this.company).collection('LOCATIONS')
    .doc(this.locations.get(Location).LOCATION_ID).update(locationData);
}

  getEventHistory(): Observable<Array<EventItem>> {
    return this.histEventRecived.asObservable();
  }

  getUsersItems(): Observable<Map<string, UserItem>> {
    return this.usersRecived.asObservable();
  }

  getTagHistory(): Observable<Array<TagItem>> {
    return this.histTagRecived.asObservable();
  }

  getLocations(): Observable<Map<string, LocationItem>> {
    return this.locationRecived.asObservable();
  }

  getMessages(): Observable<Map<string, MessageItem>> {
    return this.messagesRecived.asObservable();
  }

  getPhotoUrl(): Observable<string> {
    return this.uploadPhotoEventRecived.asObservable();
  }

  getUploadedPhotos(): Observable<Map<number, string>> {
    return this.photosUploaded.asObservable();
  }

  getLoginStatus(): Observable<boolean> {
    return this.loginStatus.asObservable();
  }

  getTagExistResult(): Observable<boolean> {
    return this.tagExist.asObservable();
  }

  getCompanyItems(): Observable<CompanyItem> {
    return this.leftTagsChanged.asObservable();
  }
}
